module.exports = __webpack_public_path__ + "img/Fast-food-combo-1.9ed0d71d.jpg";